// assets/product-sample-module.js

(function () {
  // Simple guard so if the script gets loaded twice, we don't bind twice
  if (window.__SS_SAMPLE_BOUND__) return;
  window.__SS_SAMPLE_BOUND__ = true;

  function normalizeImageUrl(url) {
    if (!url || typeof url !== "string") return "";
    let out = url.trim();

    // Email clients + Shopify notification sanitization prefer absolute URLs
    if (out.startsWith("//")) out = "https:" + out;
    else if (out.startsWith("/")) out = window.location.origin + out;

    return out;
  }


  function setButtonLoading(btn, isLoading) {
    if (!btn) return false;

    if (isLoading) {
      // prevent double-clicks / duplicate adds
      if (btn.dataset.ssLoading === "1") return false;

      btn.dataset.ssLoading = "1";
      btn.dataset.ssOriginalText = btn.textContent || "";

      btn.disabled = true;
      btn.setAttribute("aria-busy", "true");
      btn.textContent = "Adding…";
      return true;
    }

    btn.dataset.ssLoading = "0";
    btn.disabled = false;
    btn.removeAttribute("aria-busy");

    if (btn.dataset.ssOriginalText) {
      btn.textContent = btn.dataset.ssOriginalText;
    }
    return true;
  }


  function handleSampleClick(event) {
    const btn = event.target.closest(".ss-sample-module__button");
    if (!btn) return;

    const started = setButtonLoading(btn, true);
    if (!started) return; // already processing

    console.log("[Sample] Button clicked:", btn);

    // Raw attribute vs dataset (helps catch naming / casing issues)
    const rawAttrImageUrl = btn.getAttribute("data-sample-for-image-url");
    const datasetImageUrl = btn.dataset.sampleForImageUrl;

    const sampleVariantId = btn.dataset.sampleProductId;
    const sampleForId = btn.dataset.sampleForId;
    const sampleForHandle = btn.dataset.sampleForHandle;
    const sampleForTitle = btn.dataset.sampleForTitle;

    // Prefer raw attribute (most reliable), then dataset
    const sampleForImageUrlRaw = rawAttrImageUrl || datasetImageUrl || "";
    const sampleForImageUrl = normalizeImageUrl(sampleForImageUrlRaw);

    console.log("[Sample] Raw attrs:", {
      "data-sample-product-id": btn.getAttribute("data-sample-product-id"),
      "data-sample-for-id": btn.getAttribute("data-sample-for-id"),
      "data-sample-for-handle": btn.getAttribute("data-sample-for-handle"),
      "data-sample-for-title": btn.getAttribute("data-sample-for-title"),
      "data-sample-for-image-url": rawAttrImageUrl,
    });

    console.log("[Sample] Dataset:", {
      sampleProductId: btn.dataset.sampleProductId,
      sampleForId: btn.dataset.sampleForId,
      sampleForHandle: btn.dataset.sampleForHandle,
      sampleForTitle: btn.dataset.sampleForTitle,
      sampleForImageUrl: datasetImageUrl,
    });

    console.log("[Sample] Resolved values:", {
      sampleVariantId,
      sampleForId,
      sampleForHandle,
      sampleForTitle,
      sampleForImageUrlRaw,
      sampleForImageUrl, // normalized
      imageUrlLength: sampleForImageUrl ? sampleForImageUrl.length : 0,
    });

    if (!sampleVariantId) {
      console.error("[Sample] No sampleVariantId found on button");
      setButtonLoading(btn, false);
      return;
    }

    const line = {
      id: Number(sampleVariantId), // variant id as number
      quantity: 1,
      properties: {
        "Sample for": sampleForTitle || "",
        _sample_for_product_id: sampleForId || "",
        _sample_for_handle: sampleForHandle || "",
        _sample_for_image_url: sampleForImageUrl || "",
      },
    };

    // ✅ Enforce max 2 samples per handle BEFORE adding
    if (window.SS_SAMPLE_LIMIT && window.SS_SAMPLE_LIMIT.enforceOrNotify) {
      window.SS_SAMPLE_LIMIT
        .enforceOrNotify(sampleForHandle, 1, 2)
        .then((result) => {
          if (!result.ok) {
            setButtonLoading(btn, false);
            return; // blocked + user notified
          }

          // proceed with add
          console.log("[Sample] Payload to /cart/add.js:", line);

          return fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(line),
          });
        })
        .then(async (res) => {
          if (!res) return; // blocked

          const text = await res.text();
          console.log("[Sample] /cart/add.js status:", res.status, res.ok, text);
          if (!res.ok) throw new Error(text || "Add failed");

          const cartRes = await fetch("/cart.js", { headers: { Accept: "application/json" } });
          const cart = await cartRes.json();

          if (window.SS_CART_BADGE && window.SS_CART_BADGE.update) {
            window.SS_CART_BADGE.update(cart);
          }
          // ✅ Success toast
          if (window.SS_NOTIFY && window.SS_NOTIFY.show) {
            window.SS_NOTIFY.show("Sample added to cart!", "success");
          } else {
            console.log("[Sample] Sample added to cart!");
          }
          setButtonLoading(btn, false);

          const added = cart.items.find(
            (it) => String(it.variant_id) === String(sampleVariantId)
          );

          console.log("[Sample] /cart.js verify:", {
            found: !!added,
            variant_id: added && added.variant_id,
            key: added && added.key,
            title: added && added.title,
            properties: added && added.properties,
            _sample_for_image_url:
              added && added.properties && added.properties._sample_for_image_url,
          });

          console.log("[Sample] Staying on page (debug mode). Sample added to cart.");
        })
        .catch((err) => {
          console.error("[Sample] Error adding sample:", err);
          setButtonLoading(btn, false);
          alert("Sorry, there was an error adding the sample to your cart.");
        });

      return; // prevent falling through to the old fetch below
    }
  }

  // Use event delegation so it works even when product content reloads
  document.addEventListener("click", handleSampleClick);
})();
